import { createContext, useContext } from "react";
import it from "./it";
import fr from "./fr";
import de from "./de";
import es from "./es";

export const DICTS = { it, fr, de, es };

const LangCtx = createContext({ lang: "it", t: it, pageKey: "home" });
export const LangProvider = LangCtx.Provider;
export const useLang = () => useContext(LangCtx);
